import React, { useEffect, useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Loader from 'react-loader';
import { useSelector, useDispatch } from 'react-redux';
import { gradebook as fetchGradebook, downloadFile } from '../../actions/credits';
import styles from './styles.module.css';

const Index = () => {
  const dispatch = useDispatch();
  const { gradebook, isLoading, downloadLoading } = useSelector((state) => state.credits);
  const userId = useSelector((state) => state.auth?.mid);

  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (userId) {
      dispatch(fetchGradebook(userId, 0));
      window.scrollTo(0, 0);
    }
  }, [dispatch, userId]);

  const handleGetPdf = () => {
    dispatch(downloadFile(userId));
  };

  const renderTabs = () => {
    return Object.keys(gradebook).map((year, index) => (
      <Tab key={index} className={styles.tab} selectedClassName={styles.tabSelected}>
        {year}
      </Tab>
    ));
  };

  const renderTabPanels = () => {
    return Object.entries(gradebook).map(([year, semesters], index) => (
      <TabPanel key={index}>
        <div className={styles.tableContainer}>
          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th className={styles.th}>Дисциплина</th>
                  <th className={styles.th}>Отчетность</th>
                  <th className={styles.th}>Оценка</th>
                  <th className={styles.th}>Дата</th>
                  <th className={styles.th}>Преподаватель</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(semesters).map(([semesterName, subjects], semIndex) => (
                  <React.Fragment key={semIndex}>
                    <tr>
                      <td colSpan={5} className={styles.semesterRow}>
                        {semesterName} семестр
                      </td>
                    </tr>
                    {subjects.map((subject) => (
                      <tr key={subject.cid}>
                        <td className={styles.td}>{subject.meta_course_name}</td>
                        <td className={styles.td}>{subject.typename}</td>
                        <td className={styles.td}>{subject.grade}</td>
                        <td className={styles.td}>{subject.certdate_txt}</td>
                        <td className={styles.td}>{subject.exam_teachers || subject.teacher}</td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </TabPanel>
    ));
  };

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.caption}>ЗАЧЁТНАЯ КНИЖКА</div>
      <div className={styles.actions}>
        <button disabled={downloadLoading} className={styles.printButton} onClick={handleGetPdf}>
          ПЕЧАТЬ

          {downloadLoading && <i className={styles.buttonLoader}><Loader color="#7b2b2a" /></i>}
        </button>
      </div>
      <Loader loaded={!isLoading} color="#7b2b2a">
        <div className={styles.tabs}>
          <Tabs selectedIndex={tabIndex} onSelect={setTabIndex}>
            <TabList className={styles.tabList}>{renderTabs()}</TabList>
            {renderTabPanels()}
          </Tabs>
        </div>
      </Loader>
    </div>
  );
};

export default Index;
